import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap"; // 필요에 따라 import 경로를 수정하세요.

export const LanguageDropdown = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng).catch((err) => {
      console.error("Language change failed", err);
    });
  };

  return (
    <Dropdown className="dd_lang">
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        {t("login-setting-language")} {/* 번역 키 */}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => changeLanguage("ko")}>한국어</Dropdown.Item>
        <Dropdown.Item onClick={() => changeLanguage("en")}>English</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
